import script from "./bg-replace-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./bg-replace-modal.vue?vue&type=script&setup=true&lang=js"

import "./bg-replace-modal.vue?vue&type=style&index=0&id=3a0c6512&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0c6512"]])

export default __exports__